import React from 'react';
import CookieConsent from 'react-cookie-consent';

interface Props {
  onAccept(): void;
  onDecline(): void;
}

export function EUOnlyCookieConsent({ onAccept, onDecline }: Props) {
  return (
    <CookieConsent
      location="bottom"
      buttonText="Accept"
      declineButtonText="Decline"
      enableDeclineButton
      cookieName="eu_cookie_consent"
      style={{ background: "#2B373B" }}
      buttonStyle={{ color: "#fff", fontSize: "14px", background: "#c58ed4" }}
      declineButtonStyle={{ color: "#fff", fontSize: "14px", background: "#555" }}
      expires={365}
      onAccept={onAccept}
      onDecline={onDecline}
    >
      We use cookies (including UserPilot) to enhance your experience. 
      You can opt-in or opt-out of tracking.
    </CookieConsent>
  );
}
